import { createContext } from 'react';
import { Issue } from '../../../constants';

export const CollectionContext = createContext<CollectionContextProps>({
	issue: undefined,
});

interface CollectionContextProps {
	issue?: Issue;
}
